//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "audiodetail",
  data(){
      return {
        audioInfo:{},
        audioData:[],
        playAll:false,
        playindex:0
      }
  },
  methods:{
    play(src){
      var audio=this.$refs.audio;
      audio.src=src;
      audio.addEventListener('ended',this.ended);
    },
    ended(){
      console.log('end',this.audioData[this.playindex].title);
      var audio=this.$refs.audio;
      if(this.playAll){
        this.playindex++;
        if(this.playindex<this.audioData.length){
          this.play(this.audioData[this.playindex].path);
        }else{
          console.log('全部播放完毕');
        }

      }
      audio.removeEventListener('ended',this.ended);
    },
    playall(){
      this.playAll=true;
      this.play(this.audioData[this.playindex].path);
    }
  },
  created() {
      this.axios.post('/xcx/Order/audioInfo',{audio_id:this.$route.params.id}).then(res=>{
        this.audioInfo=res.data.data.info;
        this.audioData=res.data.data.item;
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/audiodetail/audiodetail.vue